// Utility function to get text direction for any language
import { CONTENT_LANGUAGES, type LanguageCode } from "@/locales";

// RTL languages list
const RTL_LANGUAGES = ['he', 'ar', 'yi'] as const;

export const getLanguageDirection = (languageCode: string): 'ltr' | 'rtl' => {
    const isValidLanguage = CONTENT_LANGUAGES.includes(languageCode as LanguageCode);
    return isValidLanguage && RTL_LANGUAGES.includes(languageCode as never) ? 'rtl' : 'ltr';
};

// Utility function to check if a language is RTL
export const isRtlLanguage = (languageCode: LanguageCode): boolean => {
    return getLanguageDirection(languageCode) === 'rtl';
};

// Get current UI language direction
export const getCurrentLanguageDirection = (): 'ltr' | 'rtl' => {
    // This can be used in components that need the current UI direction
    return getLanguageDirection(document.documentElement.dir === 'rtl' ? 'he' : 'en');
};